export default __webpack_public_path__ + "assets/images/15ee3fff042badcda96595a5b1538b9b.png";